import * as React from 'react'

const Walker = (props: any) => (
  <svg {...props} viewBox='0 0 13 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 13.6216L1.05339 3.83407C1.2881 1.65326 3.12884 0 5.32224 0V0C7.53108 0 9.37951 1.67592 9.59522 3.8742L10.3608 11.6757'
      transform='translate(1 1)'
      stroke='#666'
      strokeWidth='1.3'
    />
    <path d='M0 0H9.21505' transform='translate(1.629 9.37)' stroke='#666' strokeWidth='1.3' />
    <path d='M0 0L4.18866 0.656464L8.16788 0' transform='translate(2.256 3.626)' stroke='#666' strokeWidth='1.3' />
    <path
      d='M2.20814 1.32432C2.20814 1.65104 1.90682 1.99865 1.42907 1.99865C0.951323 1.99865 0.65 1.65104 0.65 1.32432C0.65 0.997613 0.951323 0.65 1.42907 0.65C1.90682 0.65 2.20814 0.997613 2.20814 1.32432Z'
      transform='translate(10.142 12.352)'
      stroke='#666'
      strokeWidth='1.3'
    />
  </svg>
)

export default Walker



// WEBPACK FOOTER //
// ./src/components/icons/ui/Walker.tsx